<template>
  <div>
    <div class="outside-container" :class="open ? 'open' : 'closed'">
      <div class="left-side-label">
        <div class="arrow-container">
          <img :src="require('@/assets/blue_arrow.svg')" alt="blue arrow" />
        </div>
        <span>Frequência e faturamento</span>
        <div class="gradient-bar" />
      </div>

      <div class="graph">
        <div class="graph-grid">
          <div
            v-for="item in ['atRisk', 'loyals', 'lowValue', 'promising']"
            :key="item"
            :class="variant === item ? `${item}-border ${item}` : `${item}`"
            @click="openDetails(item)"
          >
            <rfv-graph-item :loading="loading" :data="graphData[item]" :variant="item" :period="period" />
          </div>
        </div>
        <div class="champions" :class="{ 'champions-border': variant === 'champions' }" @click="openDetails('champions')">
          <rfv-graph-item :loading="loading" :data="graphData.champions" variant="champions" :period="period" />
        </div>
        <div class="bottom-arrow mt-2">
          <div class="gradient-bar" />
          <span>Recência</span>
          <img :src="require('@/assets/blue_arrow.svg')" alt="blue arrow" />
        </div>
      </div>

      <div v-if="open" class="right-side">
        <rfv-graph-details
          :variant="variant"
          :data="detailsData"
          :period="period"
          :loading="loading"
          @close="open = false"
          @more-details="$emit('more-details')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RfvGraphDetails from './RfvGraphDetails.vue'
import RfvGraphItem from './RfvGraphItem.vue'
export default {
  name: 'RfvGraph',
  components: { RfvGraphDetails, RfvGraphItem },
  props: {
    period: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    open: false,
    variant: '',
  }),
  computed: {
    ...mapGetters(['currentClientsMetrics']),
    graphData() {
      return {
        atRisk: {
          title: 'Em risco',
          clients: this.currentClientsMetrics?.atRisk?.metrics?.clients ?? '-',
          value: this.currentClientsMetrics?.atRisk?.metrics?.revenue ?? '-',
        },
        loyals: {
          title: 'Clientes leais',
          clients: this.currentClientsMetrics?.loyals?.metrics?.clients ?? '-',
          value: this.currentClientsMetrics?.loyals?.metrics?.revenue ?? '-',
        },
        lowValue: {
          title: 'Baixo valor',
          clients: this.currentClientsMetrics?.lowValue?.metrics?.clients ?? '-',
          value: this.currentClientsMetrics?.lowValue?.metrics?.revenue ?? '-',
        },
        promising: {
          title: 'Promissores',
          clients: this.currentClientsMetrics?.promising?.metrics?.clients ?? '-',
          value: this.currentClientsMetrics?.promising?.metrics?.revenue ?? '-',
        },
        champions: {
          title: 'Campeões',
          clients: this.currentClientsMetrics?.champions?.metrics?.clients ?? '-',
          value: this.currentClientsMetrics?.champions?.metrics?.revenue ?? '-',
        },
      }
    },
    detailsData() {
      const clients = this.currentClientsMetrics?.[this.variant]?.metrics?.clients ?? 0
      return {
        clients: this.currentClientsMetrics?.[this.variant]?.metrics?.clients ?? '-',
        revenue: this.currentClientsMetrics?.[this.variant]?.metrics?.revenue ?? '-',
        frequency: this.currentClientsMetrics?.[this.variant]?.metrics?.frequency ?? '-',
        recency: this.currentClientsMetrics?.[this.variant]?.metrics?.recency ?? '-',
        percentageRevenue: Math.round(this.currentClientsMetrics?.[this.variant]?.metrics?.percentageRevenue) ?? '-',
        channels: {
          app: clients ? (100 * this.currentClientsMetrics?.[this.variant]?.channels?.app) / clients : 0,
          email: clients ? (100 * this.currentClientsMetrics?.[this.variant]?.channels?.email) / clients : 0,
          sms: clients ? (100 * this.currentClientsMetrics?.[this.variant]?.channels?.sms) / clients : 0,
          whatsapp: clients ? (100 * this.currentClientsMetrics?.[this.variant]?.channels?.whatsapp) / clients : 0,
        },
      }
    },
  },
  methods: {
    openDetails(variant) {
      if (this.variant === variant) {
        this.open = false
        this.variant = ''
      } else {
        this.open = true
        this.variant = variant
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.closed {
  grid-template-columns: 42px 1fr 0;
}

.open {
  grid-template-columns: 42px 1fr 420px;
}

.right-side {
  overflow: hidden;
  overflow-x: hidden;
}

.outside-container {
  display: grid;
  width: 100%;
  height: 500px;
  position: relative;
  transition: 500ms;

  .left-side-label {
    display: flex;
    flex-direction: column;
    align-items: center;

    .arrow-container {
      height: 70px;
      width: 100%;
      display: flex;
      align-items: center;
      transform: rotate(270deg);
      margin-top: 20px;
    }

    span {
      font-size: 18px;
      transform: rotate(-90deg);
      font-weight: 700;
      line-height: 120%;
      margin-top: 80px;
      text-align: center;
      display: block;
      white-space: nowrap;
      background: $cinza-l90;
      padding: 0 10px;
    }

    .gradient-bar {
      height: calc(100% - 210px);
      width: 3px;
      background: linear-gradient(to bottom, #0080ff, #002040 48.23%, transparent 100%);
    }
  }

  .graph {
    border-radius: 8px;
    height: calc(100% - 17px);
    transition: width 1s;
    position: relative;
  }
}

.graph-grid {
  width: 100%;
  height: 100%;
  display: grid;
  border-radius: 8px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: repeat(7, 1fr);
  cursor: pointer;

  .atRisk {
    width: 100%;
    height: 100%;
    background-color: #ffc34e;
    grid-row: 1 / 5;
    border-radius: 8px 0 0 0;
    border: 2px solid transparent;
  }
  .loyals {
    grid-row: 1 / 4;
    width: 100%;
    height: 100%;
    background-color: #31d472;
    border-radius: 0 12px 0 0;
    border: 2px solid transparent;
  }
  .lowValue {
    grid-row: 5 / 8;
    width: 100%;
    height: 100%;
    background-color: #ff7459;
    border-radius: 0 0 0 8px;
    border: 2px solid transparent;
  }
  .promising {
    grid-row: 4 / 8;
    width: 100%;
    height: 100%;
    background-color: #54aaff;
    border-radius: 0 0 8px 0;
    border: 2px solid transparent;
  }
}

.champions {
  width: 240px;
  height: 120px;
  border-radius: 0 8px;
  background-color: #d4ff00;
  position: absolute;
  right: 0;
  top: 0;
  border: 2px solid transparent;
  cursor: pointer;
}

.atRisk-border {
  border-color: #bf923a !important;
}
.loyals-border {
  border-color: #208c4c !important;
}
.lowValue-border {
  border-color: #bf5742 !important;
}
.promising-border {
  border-color: #3f80bf !important;
}
.champions-border {
  border-color: #9fbf00 !important;
}

.bottom-arrow {
  display: flex;
  align-items: center;
  gap: 10px;
  .gradient-bar {
    height: 3px;
    width: 100%;
    background: linear-gradient(to left, #0080ff, #002040 48.23%, transparent 100%);
  }

  span {
    font-size: 18px;
    font-weight: 700;
    line-height: 120%;
    margin: 0;
  }
}
</style>
